import { store } from "@core/store"
import { userbotApi } from "../../store/userbotApi"
import { getChainerError } from "../clients/chainerError"
import { MassOpsRunner } from "./massOpsRunner"
import type { MassOpsTransport } from "./massOpsRunner"
import { serializeLaunchTarget } from "../common/launchTarget"

/**
 * Единственная точка прошивки раннера в RTK Query: императивные dispatch
 * эндпоинтов + нормализация ошибок через getChainerError.
 */
const transport: MassOpsTransport = {
  async importTdata(body: FormData) {
    try {
      const res = await store
        .dispatch(userbotApi.endpoints.tdataImport.initiate({ body }))
        .unwrap()
      return { id: res.id }
    } catch (e) {
      throw new Error(getChainerError(e).message)
    }
  },
  async runTemplate(
    id: string,
    body: { inputs: Record<string, unknown>; clientId?: string; role?: string },
  ) {
    try {
      const res = await store
        .dispatch(
          userbotApi.endpoints.runTemplate.initiate({
            id,
            body: {
              inputs: body.inputs,
              ...serializeLaunchTarget({
                executor: body.clientId ? "client" : "role",
                clientId: body.clientId,
                role: body.role,
              }),
            },
          }),
        )
        .unwrap()
      // Only single-chain launches have a chain report ID. Groups/schedules are not chains.
      return {
        id:
          res.kind === "chain" && !("kind" in res.result)
            ? res.result.id
            : undefined,
      }
    } catch (e) {
      throw new Error(getChainerError(e).message)
    }
  },
}

export const massOpsRunner = new MassOpsRunner(transport)
